import { Flex, Box, Text } from "rebass/styled-components";
import Heading from "../common/Heading";
import Icon from "../common/Icon";

import {
  stepsGroupStyles,
  stepDetailStyles
} from "../../lib/styles/landingStyles";

type DetailInfo = { text: string; color: string };

export interface ServiceDetailProps {
  icon: DetailInfo;
  title?: DetailInfo;
  desc: DetailInfo;
  variant?: string;
}

export function StepDetail(props: ServiceDetailProps) {
  const { icon, title, desc, variant } = props;

  const headingStyle =
    stepDetailStyles[`heading${variant}` as keyof typeof stepDetailStyles];

  return (
    <Flex flexDirection="column">
      <Flex mt={4}>
        <Box sx={{ ...stepDetailStyles.serviceIcon, borderColor: icon.color }}>
          <Icon name={icon.text} color={icon.color} fontSize={7} />
        </Box>
        <Flex sx={stepDetailStyles.box}>
          {title && (
            <Heading as="h4" sx={{ ...headingStyle, color: title.color }}>
              {title.text}
            </Heading>
          )}
          <Text
            as="p"
            sx={{ ...(title && stepDetailStyles.text), color: desc.color }}
          >
            {desc.text}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}

export interface InfoStepsGroupDetail {
  title: string;
  infoObjList: { icon: DetailInfo; title?: DetailInfo; desc: DetailInfo }[];
}

interface StepsGroupDetailProps {
  variant: string;
  infoLeft: InfoStepsGroupDetail;
  infoRight: InfoStepsGroupDetail;
}

export function StepDetailSection({
  stepInfo
}: {
  stepInfo: InfoStepsGroupDetail;
}) {
  return (
    <>
      <Heading as="h2" sx={stepsGroupStyles.heading}>
        {stepInfo.title}
      </Heading>
      {stepInfo.infoObjList.map((info, key) => (
        <StepDetail
          key={key}
          icon={info.icon}
          title={info.title}
          desc={info.desc}
        />
      ))}
    </>
  );
}

function StepsGroupDetail(props: StepsGroupDetailProps) {
  const { variant, infoLeft, infoRight } = props;

  const containerStyle =
    stepsGroupStyles.flex[variant as keyof typeof stepsGroupStyles.flex];
  const leftStyle = infoRight
    ? stepsGroupStyles.mainBoxLeft
    : stepsGroupStyles.mainBoxUnique;

  return (
    <Flex variant={`stepsGroup.flex.${variant}`} sx={containerStyle}>
      <Box sx={leftStyle}>
        <StepDetailSection stepInfo={infoLeft} />
      </Box>
      <Box sx={stepsGroupStyles.mainBoxRight}>
        <StepDetailSection stepInfo={infoRight} />
      </Box>
    </Flex>
  );
}

export default StepsGroupDetail;
